import { render, staticRenderFns } from "./StepTwelve.vue?vue&type=template&id=2654a173&"
import script from "./StepTwelve.vue?vue&type=script&lang=js&"
export * from "./StepTwelve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports